import {useCallback, useContext} from "react";
import {isCurrentPageDenyQuery, useContinueApi} from "../services/api/ApiContext";
import {getUserLogins} from "../services/api/profileApi";
import {useOktaAuth} from "@okta/okta-react";
import {useQueryClient} from "react-query";
import {useLocation} from "react-use";

const {createContext} = require("react");

const loginLogContext = createContext(null);

const getUserFactorProcess = ({data}) => ({
	logs: data?.data?.logs ?? [],
	afterToken: data?.data?.afterToken,
})

export const LoginLogProvider = ({children}) => {
	const {authState} = useOktaAuth();
	const location = useLocation();
	const queryClient = useQueryClient();
	const denyQuery = isCurrentPageDenyQuery(location)

	const { data, fetchNextPage, hasNextPage, isFetching } = useContinueApi(['getLoginLog', authState?.accessToken], getUserLogins, getUserFactorProcess, {
		enabled: !denyQuery && !!authState?.isAuthenticated && !!authState?.accessToken,
		getNextPageParam: (lastData) => lastData?.afterToken,
	});

	const logs = data?.pages.flatMap((page) => page.logs);

	const hasMore = hasNextPage;

	const getNext = () => fetchNextPage();

	const refresh = useCallback(() => queryClient.resetQueries('getLoginLog'), [queryClient]);

	return (
		<loginLogContext.Provider value={{
			data: { logs },
			hasMore,
			getNext,
			isFetching,
			refresh,
		}}>
			{children}
		</loginLogContext.Provider>
	);
}

export const useLoginLog = () => useContext(loginLogContext);
